import { zfTranslations } from "./zf_translations";
import { zfUtils } from "./zf_utils";
export class zfcCharts {
    static hasChartTargets() {
        return $(".zfcc-charts:not(.zfcc-charts-initialized)").length > 0;
    }
    static prefetchIfPresent() {
        if (!zfcCharts.hasChartTargets() || zfcCharts.chartPrefetchScheduled)
            return;
        zfcCharts.chartPrefetchScheduled = true;
        const prefetch = function () {
            zfcCharts.ensureChartJsLoaded();
        };
        const requestIdle = window.requestIdleCallback;
        if (typeof requestIdle === "function")
            requestIdle(prefetch);
        else
            setTimeout(prefetch, 0);
    }
    static ensureChartJsLoaded() {
        if (zfcCharts.chartJsReady && zfcCharts.ChartCtor)
            return Promise.resolve(true);
        if (zfcCharts.chartJsLoadPromise)
            return zfcCharts.chartJsLoadPromise;
        zfcCharts.chartJsLoadPromise = import("chart.js")
            .then(function (chartJs) {
            var _a, _b;
            const ChartCtor = chartJs.Chart || ((_a = chartJs.default) === null || _a === void 0 ? void 0 : _a.Chart) || chartJs.default;
            const registerables = chartJs.registerables || ((_b = chartJs.default) === null || _b === void 0 ? void 0 : _b.registerables) || [];
            if (!ChartCtor)
                return false;
            if (!zfcCharts.chartJsReady) {
                ChartCtor.register(...registerables);
                zfcCharts.chartJsReady = true;
            }
            zfcCharts.ChartCtor = ChartCtor;
            return true;
        })
            .catch(function () {
            zfcCharts.chartJsLoadPromise = undefined;
            return false;
        });
        return zfcCharts.chartJsLoadPromise;
    }
    static setColors(size) {
        var myColors = [];
        var myColorsOpacity = [];
        zfcCharts.mappings[size - 1].forEach(function (d) {
            myColorsOpacity.push(zfcCharts.colorsWithOpacityOptions[d - 1]);
            myColors.push(zfcCharts.defaultColorOptions[d - 1]);
        });
        zfcCharts.colorsWithOpacity = myColorsOpacity;
        zfcCharts.defaulColors = myColors;
    }
    static processData(obj, el) {
        const dataset = obj.data.datasets;
        zfcCharts.setColors(obj.data.labels.length > dataset.length
            ? obj.data.labels.length
            : dataset.length);
        if (obj.type === "doughnut") {
            dataset.forEach(function (d) {
                d.backgroundColor = zfcCharts.defaulColors;
                d.hoverBackgroundColor = zfcCharts.colorsWithOpacity;
            });
        }
        else {
            dataset.forEach(function (d, index) {
                d.backgroundColor = [];
                d.categoryPercentage = 0.92;
                d.barPercentage = 0.92;
                var setTransparent = ["bar", "horizontalBar"].indexOf(obj.type) > -1;
                if (setTransparent) {
                    d.hoverBackgroundColor = [];
                }
                d.data.forEach(function () {
                    if (setTransparent) {
                        d.backgroundColor.push(zfcCharts.defaulColors[index]);
                        d.hoverBackgroundColor.push(zfcCharts.colorsWithOpacity[index]);
                    }
                    else {
                        d.backgroundColor.push(zfcCharts.defaulColors[index]);
                    }
                });
            });
        }
        switch (obj.type) {
            case "bar":
                obj.options.plugins.tooltip["afterDatasetsDraw"] = function (chartInstance) {
                    if (chartInstance.config.drawRightBorder) {
                        var lineLeftOffset = chartInstance.chartArea.right;
                        var scale = chartInstance.scales.y;
                        var context = chartInstance.chart.ctx;
                        context.beginPath();
                        context.strokeStyle = "rgba(0, 0, 0, 0.1)";
                        context.moveTo(lineLeftOffset, scale.top);
                        context.lineTo(lineLeftOffset, scale.bottom);
                        context.stroke();
                    }
                };
                obj.drawRightBorder = true;
                break;
            case "line":
                dataset.forEach(function (d, index) {
                    d.fill = false;
                    d.lineTension = 0;
                    d.spanGaps = true;
                    d.pointStyle = "circle";
                    d.borderWidth = 1;
                    d.pointRadius = zfcCharts.isSmallScreen(el) ? 4 : 6;
                    d.pointHoverRadius = zfcCharts.isSmallScreen(el) ? 7 : 10;
                    d.borderColor = zfcCharts.defaulColors[index];
                });
                break;
            case "bubble":
                var sorted_r_list = [];
                var original_r = [];
                dataset.forEach(function (d, index) {
                    d.backgroundColor = zfcCharts.colorsWithOpacity[index];
                    d.hoverBackgroundColor = zfcCharts.colorsWithOpacity[index];
                    d.hoverRadius = 0;
                    var new_data = [];
                    original_r.push([]);
                    d.data.forEach(function (_d) {
                        var splitted = _d.split(";");
                        sorted_r_list.push(parseInt(splitted[2], 10));
                        new_data.push({
                            x: parseInt(splitted[0], 10),
                            y: parseInt(splitted[1], 10),
                            r: parseInt(splitted[2], 10),
                        });
                    });
                    d.data = new_data;
                });
                sorted_r_list.sort();
                var maxRadiusData = sorted_r_list[sorted_r_list.length - 1], minRadiusData = sorted_r_list[0];
                var bubbleMaxMinRadius = zfcCharts.getBubbleMaxMinRadius(el);
                var maxRadius = bubbleMaxMinRadius[1], minRadius = bubbleMaxMinRadius[0];
                var radiusDataFaktor = (maxRadiusData - minRadiusData) / 100;
                var radiusFaktor = (maxRadius - minRadius) / 100;
                dataset.forEach(function (d, index) {
                    d.data.forEach(function (_d) {
                        original_r[index].push(_d.r);
                        var f = (_d.r - minRadiusData) / radiusDataFaktor;
                        var p = f * radiusFaktor + minRadius;
                        _d.r = Math.round(p);
                    });
                });
                el[0].original_r = original_r;
                break;
        }
    }
    static getBubbleMaxMinRadius(el) {
        if (zfcCharts.isSmallScreen(el)) {
            return [10, 20];
        }
        return [10, 40];
    }
    static getData(el) {
        var obj = {
            type: el.data("type").replace("horizontalBar", "bar"),
            data: {
                labels: el.data("labels").split(","),
                datasets: el.data("dataset"),
            },
            options: zfcCharts.getDefaultOptions(el),
            plugins: [
                {
                    id: "htmlLegend",
                    afterUpdate(chart) {
                        const items = chart.options.plugins.legend.labels.generateLabels(chart);
                        zfcCharts.setColors(items.length);
                        var toggle = function (item) {
                            if (item.hasClass("inactive")) {
                                item.removeClass("inactive");
                                return true;
                            }
                            else {
                                item.addClass("inactive");
                                return false;
                            }
                        };
                        var legendWrapper = $('<div class="zfcc-charts-legend"></div>');
                        if (chart.config.type === "doughnut") {
                            items.forEach(function (d, index) {
                                var meta = chart.getDatasetMeta(index);
                                var item = $('<span class="zfcc-charts-legend-item ' +
                                    (chart._metasets[0].data[index].hidden ? "inactive" : "") +
                                    '"><div class="zfcc-charts-legend-item-color" style="background-color: ' +
                                    d.fillStyle +
                                    '"></div>' +
                                    d.text +
                                    "</span>");
                                legendWrapper.append(item);
                            });
                        }
                        else if (chart.config.type === "bubble") {
                            var labels = chart.data.labels;
                            items.forEach(function (d, index) {
                                var meta = chart.getDatasetMeta(index);
                                if (!el.hasClass("zfcc-charts-initialized") &&
                                    index != 0 &&
                                    el.data("displaysinglerow"))
                                    meta.hidden = true;
                                var item = $('<button class="zfcc-charts-legend-item ' +
                                    (meta.hidden ? "inactive" : "") +
                                    '" tabindex="0"><div class="zfcc-charts-legend-item-color" style="background-color: ' +
                                    zfcCharts.defaulColors[index] +
                                    '"></div>' +
                                    labels[index] +
                                    "</button>");
                                item.on("click", function () {
                                    var enabled = toggle($(this));
                                    if (el.data("displaysinglerow")) {
                                        for (var x = 0; x < chart.data.datasets.length; x++) {
                                            chart.getDatasetMeta(x).hidden = true;
                                        }
                                    }
                                    meta.hidden = !enabled;
                                    chart.update();
                                });
                                legendWrapper.append(item);
                            });
                        }
                        else {
                            items.forEach(function (d, index) {
                                var meta = chart.getDatasetMeta(index);
                                if (!el.hasClass("zfcc-charts-initialized") &&
                                    index != 0 &&
                                    el.data("displaysinglerow"))
                                    meta.hidden = true;
                                var item = $('<button class="zfcc-charts-legend-item ' +
                                    (meta.hidden ? "inactive" : "") +
                                    '" tabindex="0"><div class="zfcc-charts-legend-item-color" style="background-color: ' +
                                    zfcCharts.defaulColors[index] +
                                    '"></div>' +
                                    d.text +
                                    "</button>");
                                item.on("click", function () {
                                    var enabled = toggle($(this));
                                    if (el.data("displaysinglerow")) {
                                        for (var x = 0; x < chart.data.datasets.length; x++) {
                                            chart.getDatasetMeta(x).hidden = true;
                                        }
                                    }
                                    meta.hidden = !enabled;
                                    chart.update();
                                });
                                legendWrapper.append(item);
                            });
                        }
                        el.find(".zfcc-charts-legend-wrapper").empty();
                        el.find(".zfcc-charts-legend-wrapper").append(legendWrapper);
                    },
                },
            ],
            units: el.data("units"),
        };
        zfcCharts.processData(obj, el);
        return obj;
    }
    static initChart(target) {
        try {
            var that = $(target);
            if (that.find(".zfcc-charts-legend-wrapper").children().length == 0) {
                that
                    .find(".zfcc-charts-legend-wrapper")
                    .attr("id", "zfcc-charts-legend-wrapper-" + zfcCharts.chartCount);
                zfcCharts.chartCount++;
            }
            const data = zfcCharts.getData(that);
            var canvas = that.find("canvas")[0].getContext("2d");
            data.instance = new zfcCharts.ChartCtor(canvas, data);
            that.addClass("zfcc-charts-initialized");
            if (that.data("displaysinglerow"))
                data.instance.update();
        }
        catch (err) {
            console.log("Initalization failed: zfcCharts.initChart() " + err);
        }
    }
    static responsiveOptions(type, options, el) {
        if (options.scales.y) {
            options.scales.y.display = !zfcCharts.isSmallScreen(el);
            options.scales.y.ticks.callback = function (value) {
                return !zfcCharts.isSmallScreen(el)
                    ? zfcCharts.formatNumber(value)
                    : "";
            };
            options.scales.y.stacked = el.data("stackmobile")
                ? options.scales.y.forceStacked || zfcCharts.isSmallScreen(el)
                : false;
        }
        if (options.scales.x) {
            options.scales.x.ticks.callback = function (value) {
                return !zfcCharts.isSmallScreen(el) ? this.getLabelForValue(value) : "";
            };
            options.scales.x.gridLines = {
                tickMarkLength: zfcCharts.isSmallScreen(el) ? -16 : 10,
            };
            options.scales.x.stacked = el.data("stackmobile")
                ? options.scales.x.forceStacked || zfcCharts.isSmallScreen(el)
                : false;
        }
        if (type === "line" && zfcCharts.isSmallScreen(el)) {
            options.layout = {
                padding: 8,
            };
        }
        if (type === "bubble" && options.scales.x && options.scales.y) {
            options.scales.x.forceStacked = false;
            options.scales.x.stacked = false;
            options.scales.y.forceStacked = false;
            options.scales.y.stacked = false;
            options.layout = {
                padding: {
                    top: zfcCharts.isSmallScreen(el) ? 20 : 40,
                    right: zfcCharts.isSmallScreen(el) ? 20 : 40,
                    bottom: 20,
                    left: 20,
                },
            };
        }
    }
    static isSmallScreen(el) {
        return el.hasClass("zfcc-charts-small") || (($(window).width() || 0) < 768);
    }
    static getDefaultOptions(el) {
        var type = el.data("type");
        var font = {
            titleSize: 24,
            labelSize: 24,
            tickSize: 16,
            labelFontFamily: '"Verdana", sans-serif',
        };
        var options = {
            responsive: true,
            events: ["mousemove", "mouseout", "click", "touchend"],
            maintainAspectRatio: false,
            onResize: function (chartParam) {
                var isSmallScreen = zfcCharts.isSmallScreen(el);
                if (chartParam.options.scales.y) {
                    chartParam.options.scales.y.display = !isSmallScreen;
                    chartParam.options.scales.y.stacked = el.data("stackmobile")
                        ? chartParam.options.scales.y.forceStacked || isSmallScreen
                        : false;
                }
                chartParam.options.scaleShowLabels = false;
                if (chartParam.options.scales.x) {
                    chartParam.options.scales.x.title.display = true;
                    chartParam.options.scales.x.stacked = el.data("stackmobile")
                        ? chartParam.options.scales.x.forceStacked || isSmallScreen
                        : false;
                    chartParam.options.scales.x.gridLines = {
                        tickMarkLength: isSmallScreen ? -16 : 10,
                    };
                }
                if (chartParam.config.type === "line") {
                    chartParam.options.layout = {
                        padding: isSmallScreen ? 8 : 10,
                    };
                    chartParam.config.data.datasets.forEach(function (d) {
                        d.pointRadius = isSmallScreen ? 4 : 6;
                        d.pointHoverRadius = isSmallScreen ? 7 : 10;
                    });
                }
                if (chartParam.config.type === "bubble" &&
                    chartParam.options.scales.x &&
                    chartParam.options.scales.y) {
                    chartParam.options.scales.x.forceStacked = false;
                    chartParam.options.scales.x.stacked = false;
                    chartParam.options.scales.y.forceStacked = false;
                    chartParam.options.scales.y.stacked = false;
                }
            },
            scales: {
                y: {
                    beginAtZero: el.data("beginatzero"),
                    forceStacked: el.data("stacked"),
                    stacked: el.data("stacked"),
                    ticks: {
                        fontSize: font.tickSize,
                        fontFamily: font.labelFontFamily,
                        callback: function (label) {
                            zfcCharts.formatNumber(parseFloat(label));
                            return zfcCharts.formatNumber(parseFloat(label));
                        },
                    },
                    title: {
                        display: true,
                        font: {
                            size: 20,
                            weight: 300,
                            family: "Prometo",
                        },
                        text: el.data("y-title"),
                    },
                },
                x: {
                    forceStacked: el.data("stacked"),
                    stacked: el.data("stacked"),
                    ticks: {
                        fontFamily: font.labelFontFamily,
                        fontSize: font.tickSize,
                    },
                    title: {
                        display: true,
                        font: {
                            size: 20,
                            weight: 300,
                            family: "Prometo",
                        },
                        text: el.data("x-title"),
                    },
                },
            },
            legend: {
                display: false,
            },
            interaction: {
                mode: "index",
            },
            plugins: {
                htmlLegend: {
                    containerID: el.find(".zfcc-charts-legend-wrapper").attr("id"),
                },
                legend: {
                    display: false,
                },
                tooltip: {
                    titleFontColor: "#333333",
                    titleMarginBottom: 12,
                    titleAlign: "center",
                    titleFontFamily: "Verdana",
                    backgroundColor: "#EEF1F4",
                    bodyFontFamily: "Verdana",
                    bodyFontColor: "#333333",
                    callbacks: {
                        label: function (data) {
                            return data.label + ": " + zfcCharts.formatNumber(data.raw);
                        },
                    },
                    enabled: false,
                    external: function (tooltipObj) {
                        var tooltipModel = tooltipObj.tooltip;
                        var tooltipEl = zfcCharts.tooltip;
                        if (!el.data("showtooltips") ||
                            !tooltipModel.dataPoints ||
                            !el.data("showtooltips")) {
                            tooltipEl.removeClass("active");
                            return;
                        }
                        tooltipEl.addClass("active");
                        zfcCharts.renderTooltip({
                            el: el,
                            datasets: el.data("dataset"),
                            tooltipModel: tooltipModel,
                            type: el.data("type"),
                            labels: el.data("labels"),
                            units: el.data("units"),
                        });
                        var position = zfcCharts.getTooltipPosition(tooltipObj.chart.canvas.getBoundingClientRect(), tooltipModel, tooltipEl);
                        tooltipEl.css(position);
                        tooltipEl.show();
                    },
                },
            },
        };
        zfcCharts.responsiveOptions(type, options, el);
        switch (type) {
            case "horizontalBar":
                options.interaction = {
                    mode: "index",
                    axis: "y",
                };
                options["indexAxis"] = "y";
                delete options.scales.y.ticks.callback;
                break;
            case "line":
            case "bar":
                options.interaction.mode = "index";
                break;
            case "doughnut":
                options.scales = false;
                options.interaction.mode = "point";
                options.plugins.tooltip.callbacks.label = function (tooltipItem) {
                    return (tooltipItem.label + ": " + zfcCharts.formatNumber(tooltipItem.raw));
                };
                options.plugins.tooltip.callbacks.title = function (tooltipItem) {
                    return tooltipItem[0].label;
                };
                break;
            case "bubble":
                options.interaction.mode = "nearest";
                break;
        }
        return options;
    }
    static renderTooltip(c) {
        var xLabel = c.el.data("x-title");
        var yLabel = c.el.data("y-title");
        var zLabel = c.el.data("z-title");
        var tooltipEl = zfcCharts.tooltip;
        var tooltipHeader = tooltipEl.find(".zfcc-charts-tooltip-header");
        var itemListContainer = tooltipEl.find(".zfcc-charts-tooltip-item-wrapper");
        var tooltipFooter = tooltipEl.find(".zfcc-charts-tooltip-footer");
        tooltipHeader.empty();
        itemListContainer.empty();
        tooltipFooter.empty();
        switch (c.type) {
            case "line":
            case "bar":
            case "horizontalBar":
                var total = 0;
                if (c.type === "horizontalBar") {
                    tooltipHeader.html(c.tooltipModel.dataPoints[0].label);
                }
                else {
                    tooltipHeader.html(c.tooltipModel.title[0]);
                }
                c.tooltipModel.dataPoints.forEach(function (dp) {
                    var dataset = c.datasets[dp.datasetIndex];
                    var value = dp.raw;
                    total += value;
                    itemListContainer.append(zfcCharts.renderTooltipItem(dataset.label, value, dataset.backgroundColor[0], c));
                });
                if (c.el.data("showtotal") == "true" &&
                    c.tooltipModel.dataPoints.length > 1) {
                    tooltipFooter.append("<span>Total</span>");
                    tooltipFooter.append("<span>" +
                        zfcCharts.formatNumber(total, undefined, c.units) +
                        "</span>");
                }
                break;
            case "doughnut":
                var dataPoints = c.tooltipModel.dataPoints[0];
                var dataset = c.datasets[dataPoints.datasetIndex];
                var color = dataset.backgroundColor[dataPoints.dataIndex];
                var data = dataset.data[dataPoints.dataIndex];
                var title = dataset.label;
                var label = dataPoints.label;
                tooltipHeader.html(title);
                itemListContainer.append(zfcCharts.renderTooltipItem(label, data, color, c));
                break;
            case "bubble":
                var original_r = c.el[0].original_r;
                var dataPoints = c.tooltipModel.dataPoints[0];
                var dataset = c.datasets[dataPoints.datasetIndex].data[dataPoints.dataIndex];
                var r_data = original_r[dataPoints.datasetIndex][dataPoints.dataIndex];
                var labelDataset = c.datasets[dataPoints.datasetIndex];
                var colorDataset = c.datasets[dataPoints.datasetIndex];
                var color = colorDataset.backgroundColor;
                var title = labelDataset.label;
                tooltipHeader.html("<span>" + title + "</span>");
                var _color = $('<div class="zfcc-charts-tooltip-item-color"></div>');
                _color.css({ "background-color": color });
                tooltipHeader.prepend(_color);
                itemListContainer.append(zfcCharts.renderTooltipItem(zLabel, r_data, undefined, c));
                itemListContainer.append(zfcCharts.renderTooltipItem(yLabel, dataset.y, undefined, c));
                itemListContainer.append(zfcCharts.renderTooltipItem(xLabel, dataset.x, undefined, c));
                break;
        }
    }
    static getTooltipPosition(position, tooltipModel, ttEl) {
        var top = position.top + window.pageYOffset + tooltipModel.caretY;
        var left = position.left + window.pageXOffset + tooltipModel.caretX;
        ttEl.removeClass("right-side");
        if (tooltipModel.caretX > position.width / 2) {
            ttEl.addClass("right-side");
        }
        return {
            top: top + "px",
            left: left + "px",
        };
    }
    static renderTooltipItem(t, v, c, o) {
        var item = $('<div class="zfcc-charts-tooltip-item"></div>');
        if (c) {
            var colorWrapper = $('<div class="zfcc-charts-tooltip-item-color-wrapper"></div>');
            var color = $('<div class="zfcc-charts-tooltip-item-color"></div>');
            color.css({ "background-color": c });
            colorWrapper.append(color);
            item.append(colorWrapper);
        }
        var label = $('<div class="zfcc-charts-tooltip-item-label">' + t + "</div>");
        var value = $('<div class="zfcc-charts-tooltip-item-value">' +
            zfcCharts.formatNumber(v, undefined, o.units) +
            "</div>");
        item.append(label);
        item.append(value);
        return item;
    }
    static formatNumber(number, lang, chart_units) {
        var _a;
        if (lang == undefined)
            lang = ((_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.lang) || "en";
        var isNegative = number < 0;
        if (isNegative) {
            number = number * -1;
        }
        var xx = number;
        var abbreviation = "", divideValue = 1, length = number.toString().length, units = {
            en: {
                bn: " bn",
                mn: " mn",
                k: " k",
                decimalSeperator: ".",
            },
            de: {
                bn: " bn",
                mn: " mn",
                k: " k",
                decimalSeperator: ",",
            },
        };
        if (length > 9) {
            divideValue = 1000000000;
            abbreviation = units[lang].bn;
        }
        var fullValue = Math.floor(number / divideValue);
        var remainderValue = number / divideValue - fullValue;
        number = fullValue;
        var numberLength = number.toString().length;
        remainderValue =
            Math.round(remainderValue * Math.pow(10, 3)) / Math.pow(10, 3);
        number = parseFloat(number +
            (remainderValue == 0
                ? ""
                : "." + remainderValue.toString().substr(2, 5)));
        if (isNegative) {
            number = number * -1;
        }
        if (chart_units && zfTranslations.get(chart_units).length > 0)
            chart_units = zfTranslations.get(chart_units);
        return (number.toLocaleString($("html").attr("lang") || "en") +
            abbreviation +
            (chart_units ? " " + chart_units : ""));
    }
    static init() {
        if (!zfcCharts.hasChartTargets())
            return;
        zfcCharts.ensureChartJsLoaded().then(function (isLoaded) {
            if (!isLoaded)
                return;
            try {
                $(".zfcc-charts:not(.zfcc-charts-initialized)").each(function () {
                    zfcCharts.tooltip = $('<div class="zfcc-charts-tooltip"></div>');
                    var tooltipInnerWrapper = $('<div class="zfcc-charts-tooltip-inner-wrapper"></div>');
                    var itemListContainer = $('<div class="zfcc-charts-tooltip-item-wrapper"></div>');
                    var tooltipHeader = $('<div class="zfcc-charts-tooltip-header"></div>');
                    var tooltipContent = $('<div class="zfcc-charts-tooltip-content"></div>');
                    var tooltipFooter = $('<div class="zfcc-charts-tooltip-footer"></div>');
                    tooltipContent.append(itemListContainer);
                    tooltipInnerWrapper.append(tooltipHeader);
                    tooltipInnerWrapper.append(tooltipContent);
                    tooltipInnerWrapper.append(tooltipFooter);
                    zfcCharts.tooltip.append(tooltipInnerWrapper);
                    $(document.body).append(zfcCharts.tooltip);
                    zfcCharts.initChart(this);
                });
            }
            catch (err) {
                console.log("Initalization failed: zfcCharts.init() " + err);
            }
        });
    }
}
zfcCharts.chartCount = 0;
zfcCharts.tooltip = null;
zfcCharts.chartJsReady = false;
zfcCharts.chartPrefetchScheduled = false;
zfcCharts.defaultColorOptions = [
    "#0057B7",
    "#00ABE7",
    "#93D5F6",
    "#00265F",
    "#514D9B",
    "#A6A1D0",
    "#00A7AB",
    "#A2D3D6",
    "#000828",
    "#CEEBFC",
];
zfcCharts.defaulColors = [];
zfcCharts.mappings = [
    [1],
    [1, 2],
    [1, 2, 3],
    [1, 2, 3, 4],
    [1, 2, 3, 4, 5],
    [1, 2, 3, 4, 5, 6],
    [1, 2, 3, 4, 5, 6, 7],
    [1, 2, 3, 4, 5, 6, 7, 8],
    [1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
];
zfcCharts.colorsWithOpacityOptions = [
    "rgba(0,87,183,0.8)",
    "rgba(0,171,231,0.8)",
    "rgba(147,213,246,0.8)",
    "rgba(0,38,95,0.8)",
    "rgba(82, 78, 156, 0.8)",
    "rgba(166, 161, 208, 0.8)",
    "rgba(0, 167, 171, 0.8)",
    "rgba(162, 211, 214, 0.8)",
    "rgba(0, 8, 40, 0.8)",
    "rgba(206, 235, 252, 0.8)",
];
zfcCharts.colorsWithOpacity = [];
try {
    zfUtils.onReady(function () {
        zfcCharts.prefetchIfPresent();
        zfcCharts.init();
    });
}
catch (err) {
    console.log("Initalization failed: zfcCharts.initChart() " + err.message);
}
